import { useEffect, useRef } from 'react';

export function usePrevious<T>(val: T): T {
  const prev = useRef<T>(val);
  useEffect(() => {
    prev.current = val;
  });
  return prev.current;
}
